import {
  SCHEDULE_STATUS_COLORS,
  SCHEDULE_STATUS_LABELS,
} from "../../utils/examsschedule/examConstants";

export default function ScheduleStatusBadge({ status }) {
  const cls =
    SCHEDULE_STATUS_COLORS[status] || "bg-gray-100 dark:bg-neutral-900 text-gray-600 dark:text-neutral-300";
  const label =
    SCHEDULE_STATUS_LABELS[status] ||
    (status || "—").replace(/_/g, " ");

  return (
    <span
      className={`inline-flex px-2 py-0.5 rounded-full text-xs font-medium ${cls}`}
    >
      {label}
    </span>
  );
}
